import { AfterViewChecked, AfterViewInit, Component, Injector, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Kmlmanager } from 'src/app/shared/kmlmanager';
import { Geoutil } from 'src/app/shared/geoutil';
import { Colorutil } from 'src/app/shared/colorutils';
import { environment } from '../../../../environments/environment';
import { LocalizedString } from '@angular/compiler';
import {BeaconscenarioComponent} from '../../beaconscenario/beaconscenario.component';
import {ILatLng,IContourdefinition,IScenarioLayout} from '../../../shared/geointerfaces'
import { ScenariolayoutComponent } from '.././scenariolayout/scenariolayout.component';

@Component({
  selector: 'app-scenarioedit2',
  templateUrl: './scenarioedit2.component.html',
  styleUrls: ['./scenarioedit2.component.css']
})
export class Scenarioedit2Component  extends BaseComponent implements OnInit,AfterViewChecked {
  @ViewChild('pagemap', { static: true }) mapElement: any = {}
  scenario: any = {}
  scenarios: any = []
  copyscenarioid = 0
  scenarioId = 0
  hasGPS = true;
  hasBeacon = false;
  organizations: any = []
  showLoadFile = false
  showKMLInfo = false
  fileName = ""
  scenariolayout: any = {}
  google_map: Google_map
  showChooseNewCenter = false
  standardscenarios: any = []
  standardscenarioid = 0
  actionid = 3
  actions: any = []
  viewObjects = false
  qrdata = "https://gpsfront-dev.cellpodium2.com/#/simulation"

  scenariosensors: any = []
  sensors: any = []
  showInstructions = false
  showTabGPS = false
  showTabGPSSensor = false
  showEditor = false
  layout:IScenarioLayout

  @ViewChild('beaconscenid') beacscen:BeaconscenarioComponent;
  @ViewChild('scenlay') scenlay:ScenariolayoutComponent;

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.initializeDropdownArrays()
    this.organizations = await this.db.get("organization", "getOrganizations")
     const resp = await this.db.get("scenario", "getscenarios")
    this.scenarios = []
    let organizationId = sessionStorage.getItem('organizationId');
    resp.forEach((s:any)=>{
      if (s.organizationId.toString() == organizationId) this.scenarios.push(s)
    })

    this.copyscenarioid = this.scenarios[0].id
    this.scenarioId = this.getIntQueryParamOrDefault("id", 1)

    //if scenarioid == 0 (new scenario)=> copy from tempalte and create new scenario
    if (this.scenarioId == 0) {
      let copyscenarioId = this.scenarios[0].id
      let organizationId = sessionStorage.getItem('organizationId');
      this.scenarioId = await this.db.get("scenario", "GetScenarioCopyId", { copyfromid: copyscenarioId, orgid: organizationId })
    }
    await this.getData()
    this.scenlay.initialize(this.scenario,this.scenariolayout)
    //await this.getData()
    this.qrdata = "https://sensorsim.cellpodium.com/#/simulation?id="+this.scenarioId
    let a = 5
  }

  ngAfterViewChecked() {
    if (this.mapElement) {
      //this.getData();
    }
  }


  async getData() {
    this.loader.show()
    this.sensors = await this.db.get("sensor", "getsensors")
    this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenarioId })
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioId })
    this.hasGPS = this.scenario.hasGPS
    this.hasBeacon = this.scenario.hasBeacon
    this.scenario.selectedType = this.scenario.hasGPS ? "GPS" : "Beacon"
    this.scenario.organizationName = this.lookup(this.scenario.organizationId,this.organizations)
    await this.beacscen.getData()
    this.loader.hide()

    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = this.createScenarioLayout(JSON.parse(this.scenario.geometryJson))

    }
  }

  createScenarioLayout(s:any){ //convert ananymous javaobject to typed scenariolayout
    let scen:IScenarioLayout = {
      center: s.center,
      contours: [],
      contourdefinitions: []
    }
    s.contours.forEach((c:any)=>{
      scen.contours.push(c)
    })
    s.contourdefinitions.forEach((cd:any)=>{scen.contourdefinitions.push(cd)})
    return scen
  }

  async save() {
    if (!this.validateForm()) return

    this.loader.show()
    this.scenario.geometryJson = JSON.stringify(this.scenariolayout)
    await this.db.post("scenariosensor", "postScenarioSensors", this.scenariosensors)

    let newScenario = await this.db.post("scenario", "postScenario", this.scenario)
    this.scenarioId = newScenario.id
    await this.getData()
    this.loader.hide()
  }
  async saveScenario(lo:any){ //beeing called as callback from scenarioloayout
    this.scenariolayout = lo
    await this.save()
  }
  validateForm() {
    let sret = ""
    let isValid = true
    if (this.scenario.name.length < 1) {
      isValid = false
      sret += "Non name provided. "
    }
    if (this.scenario.organizationId < 1) {
      isValid = false
      sret += "No organiztion provided. "
    }
    if (isValid == false) this.alert.warning(sret)
    return isValid
  }


  actionHasChanged($event: any){
    if ($event == 1){this.createNewScenario()}
  }


  async createNewScenario(){
    this.scenario = this.scenarios[0] //take the first scenario
    const now = new Date();

    this.scenario.name = "New Scenario "+now.toLocaleDateString()
    this.scenario.description = "New Scenario "+now.toLocaleDateString()
    this.scenariolayout = { center: { lat: 35.2271, lng: -80.8431 }, contours: [], contourdefinitions: [] }

    this.scenariosensors = [];
    await this.db.delete("scenariosensor", "deleteScenarioSensorsByScenId", { scenarioId: this.scenarioId })
    let sensor = { id: 1 }
    await this.addSensorToScenarioSensors(sensor)
    this.standardscenarioid = 4
    this.selectStandardScenario()
  }

  showMap() {
    // this.google_map = new Google_map()
    // let latlng = this.scenariolayout.center
    // let zoom = this.getZoom()

    // this.scenariolayout.contours.forEach((p: any, i: number) => {
    //   let color = this.scenariolayout.contourdefinitions[i].color;
    //   this.google_map.addPolygon(p, color)
    // })

    // this.google_map.clickOnMap((res: any) => {
    //   let latlng = res.latLng.toJSON();
    //   if (this.showChooseNewCenter == true) {
    //     let oldCenter = this.scenariolayout.center != null ? this.scenariolayout.center : null
    //     this.scenariolayout.center = latlng
    //     this.showChooseNewCenter = false

    //     if (oldCenter != null) {
    //       this.repositionScenario(oldCenter, latlng)
    //       this.showMap()
    //     }
    //   };

    // })
  }

  getZoom() {
    let result = 15
    let min = 0
    let max = 0
    if (this.scenariolayout.contours.length > 0) {
      min = this.scenariolayout.contours[0][0].lat
      max = this.scenariolayout.contours[0][0].lat
      this.scenariolayout.contours.forEach((c: any) => {
        c.forEach((ll: any) => {
          if (ll.lat < min) min = ll.lat
          if (ll.lat > max) max = ll.lat
        })
      })
      let diff = max - min
      if (diff < 0.010 ) result = 17
      if (diff < 0.002 ) result = 18
    }
    return result
  }
  setOrChangeCenter() {
    this.showChooseNewCenter = true;
  }

  selectStandardScenario() {
    if (this.standardscenarioid > 0) {
      let standDef = this.standardscenarios.find((x: any) => x.id == this.standardscenarioid)
      if (this.scenariolayout != null) {
        this.scenariolayout.contours = []
        this.scenariolayout.contourdefinitions = []
      }
      for (let i = 1; i <= standDef.nCircles; i++) {
        let radius = i / standDef.nCircles * standDef.radius
        let circle = Geoutil.getCircleArray(this.scenariolayout.center, radius, 24)
        this.scenariolayout.contours.push(circle);
      }

      let nContours = this.scenariolayout.contours.length
      let colors = Colorutil.generateColorPalette({ r: 255, g: 0, b: 0 }, { r: 255, g: 255, b: 0 }, nContours)
      for (let i = 0; i < nContours; i++) {
        let exposure = 100 - i / (nContours - 1) * 100;
        this.scenariolayout.contourdefinitions.push({ color: colors[i], exposure: exposure });
      }
      this.showMap()
    }
    else {
      this.alert.warning("Please, choose a standard scenario first!");
    }
  }
  repositionScenario(oldCenter: any, newCenter: any) {
    let difLat = newCenter.lat - oldCenter.lat
    let difLng = newCenter.lng - oldCenter.lng
    this.scenariolayout.contours.forEach((c: any) => {
      c.forEach((p: any) => {
        p.lat += difLat
        p.lng += difLng
      })
    })
  }
  receiveFileAsString($event: any) {
    this.fileName = $event.fileName
    this.scenario.kmlstring = $event.fileData
    let KML = new Kmlmanager($event.fileData)
    this.layout = KML.scenariolayout
    this.scenario.geometryJson = JSON.stringify(this.layout);
    this.showLoadFile = false;
    this.showKMLInfo = true;
    this.showMap();
  }
  clearScenario() {
    //this.scenariolayout = { center: { lat: 35.2271, lng: -80.8431 }, contours: [], contourdefinitions: [] }
    //this.showMap()
  }

  checkModeFlags($event: any) {
    if (!this.hasGPS && !this.hasBeacon) {
      this.scenario.hasGPS = true
      this.scenario.hasBeacon = false;

    } else {
      this.scenario.hasGPS = this.hasGPS
      this.scenario.hasBeacon = this.hasBeacon
    }
    this.save()
  }

  initializeDropdownArrays() {
    this.actions = [
      { id: 1, name: "Start fresh" },
      { id: 2, name: "Load KML file" },
      { id: 3, name: "Move center" },
      { id: 4, name: "Select standard scenario" },
      { id: 5, name: "Copy from other scenario" }
    ]
    this.standardscenarios = [
      { id: 1, name: "5 circles 100m radius", nCircles: 5, radius: 100 },
      { id: 2, name: "5 circles 500m radius", nCircles: 5, radius: 500 },
      { id: 3, name: "5 circles 1000m radius", nCircles: 5, radius: 1000 },
      { id: 4, name: "15 circles 100m radius", nCircles: 15, radius: 100 },
      { id: 5, name: "50 circles 100m radius", nCircles: 50, radius: 100 }
    ];
  }
  async copyFromScenario() {
    let ccscenario = await this.db.get("scenario", "getscenario", { id: this.copyscenarioid });
    this.scenario.geometryJson = ccscenario.geometryJson
    this.scenariolayout = JSON.parse(this.scenario.geometryJson)
    this.showMap()
  }
  async addSensorToScenarioSensors(sensor: any) {
    let ssnew = this.scenariosensors.find((ss: any) => ss.sensorId == sensor.id)
    if (ssnew == null) {
      ssnew = { id: 0, sensorId: sensor.id, scenarioid: this.scenarioId, seqno: 10, gpsMaxReading: 50 }
      await this.db.post("scenariosensor", "postScenarioSensor", ssnew)
      this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenarioId })
    } else {
      this.toast.info("This sensor is already selected!")
    }
  }

  async saveScenarioSensor(sensor: any) {
    await this.db.post("scenariosensor", "postScenarioSensor", sensor)
    this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenarioId })
  }

  async deleteScenarioSensor(sensor: any) {
    await this.db.delete("scenariosensor", "deleteScenarioSensor", { id: sensor.id })
    this.scenariosensors = await this.db.get("scenariosensor", "getscenariosensorsbyscen", { scenarioid: this.scenarioId })
  }

  descriptionChanged($event: any){
    this.scenario.description = $event
    this.showEditor = false
  }

  selectedTypeChange($event:any){
    this.scenario.hasGPS = $event == "GPS" ? true : false
    this.save()
  }

}
